module.exports = __webpack_public_path__ + "static/img/sec 03.fe68cd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/sec 03.png
// module id = BYHT
// module chunks = 13